<template>
	<div class="expertThinkTank">
		<comHead :tabIndexI="3" :imgSrc="imgSrc" />
		<div class="content-bg">
			<div class="content" id="position001">
				<el-tabs v-model="selectedType" @tab-click="selectType">
					<el-tab-pane v-for="(item, index) in types.filter((p) => p.parentId == 0)" :key="index"
						:label="item.text" :name="item.id + ''">
					</el-tab-pane>
					<!-- <el-tab-pane label="商标类" name="trademark"> </el-tab-pane>
          <el-tab-pane label="地理标志类" name="geographic"></el-tab-pane>
          <el-tab-pane label="区域品牌确权" name="brand"></el-tab-pane>
          <el-tab-pane label="专利类" name="patent"></el-tab-pane>
          <el-tab-pane label="互联网类" name="Internet"></el-tab-pane> -->
				</el-tabs>
				<div class="el_input">
					<el-input v-model="txtQuery" />
					<span @click="search">搜索</span>
				</div>
			</div>
		</div>
		<!-- <div class="serviceBg">
      <div class="serveContent">
        <h1>服务优势</h1>
        <ul class="serveDescribe">
          <li>
            <div class="servicePhoto">
              <img src="../../static/imgs/serviceCase/icon-1.png" alt="" />
            </div>
            <p class="serviceParagraph">
              200+余项知识产权全产业链服务，拥有22家子公司和关联机构，先后为30余万客户提供不同类型的多元化知识产权服务，服务范围涉及全国684个县级行政区，服务范围辐射11个省份
              （云南、四川、重庆、贵州、新疆、西藏、青海、甘肃、陕西、湖北、河南），覆盖全球130多个国家和地区
            </p>
          </li>
          <li>
            <div class="servicePhoto">
              <img src="../../static/imgs/serviceCase/icon-2.png" alt="" />
            </div>
            <p class="serviceParagraph">
              累积服务30余万客户，注册初审率及各类案件成功率均高于全国平均水平，代理商标案件7000余件，代理地理标志证明商标1000余件，帮助驰名商标企业维权保护50余起。为国内100多
              家大型知名企业咨询服务了ISO9001、能源管理体系等。为各大农业生产企业取得认证200余件。涉外商标代理整体成功率整体90%以上，其中欧盟涉外代理成功率100%
            </p>
          </li>
        </ul>
      </div>
    </div> -->
		<div class="classification">
			<div class="middle">
				<el-button round class="button" v-for="(item, index) in classification" :key="index"
					@click="selectClass(item.id)" :class="selectedClass == item.id ? 'checked' : ''">{{ item.text }}
				</el-button>
			</div>
		</div>
		<section class="expertThinkTank_center">
			<ul class="caseCentral">
				<li class="caseDescription" v-for="(item, index) in list" :key="index">
					<div class="casephoto">
						<img :src="$urlFile + item.PictureUrl" alt="" />
					</div>
					<div class="caseSection">
						<h1>{{ item.CaseName }}</h1>
						<p>{{ item.CaseContent }}</p>
					</div>
				</li>
			</ul>
		</section>
		<div class="pagination">
			<el-pagination layout="prev, pager, next" @current-change="pageIndexChange" :current-page.sync="pageIndex"
				:page-size="pageSize" :total="totalCount">
			</el-pagination>
		</div>
		<comFooter />
	</div>
</template>

<script>
	import {
		getCaseTypes,
		getCaseList
	} from "../request/api.js";
	export default {
		data() {
			return {
				imgSrc: require("../../static/imgs/serviceCase/fuwuanli.jpg"),
				positionID: this.$route.query.positionID,
				types: [],
				classification: [],
				list: [],
				pageIndex: 1,
				pageSize: 6,
				totalCount: 0,
				txtQuery: "",
				searchCase: "",
				selectedType: 0,
				selectedClass: 0,
			};
		},
		created() {
			getCaseTypes().then((data) => {
				if (data.StatusCode == 200) {
					this.types = data.Result || [];
					if (this.positionID) {
						this.afterLoad();
					} else {
						this.selectType({
							name: this.types.filter((p) => p.parentId == 0)[0].id + ""
						});
					}
				} else console.log(data.Msg);
			});
		},
		mounted() {
			if (this.positionID) {
				this.selectedTab = Number(this.positionID.substr(-1));
				document.querySelector("#position001").scrollIntoView(true);
			}
		},
		methods: {
			selectType(tab, event) {
				this.selectedType = tab.name;
				this.classification = this.types.filter(
					(p) => p.parentId == this.selectedType
				);
				this.selectedClass =
					this.classification.length > 0 ? this.classification[0].id : 0;
				this.txtQuery = "";
				this.searchCase = "";
				this.loadList();
			},
			selectClass(id) {
				this.selectedClass = id;
				this.loadList();
			},
			search() {
				this.pageIndex = 1;
				this.searchCase = this.txtQuery;
				this.loadList();
			},
			pageIndexChange(val) {
				this.pageIndex = val;
				this.loadList();
			},
			loadList() {
				if (this.selectedClass == 0) {
					this.list = [];
					return;
				}
				getCaseList({
					PageInfo: {
						PageIndex: this.pageIndex - 1,
						PageSize: this.pageSize,
					},
					CaseName: this.searchCase,
					ClassificationId: this.selectedClass,
				}).then((data) => {
					console.log(data.Result);
					this.list = data.Result;
					this.totalCount = data.TotalCount;
				});
			},
			afterLoad() {
				document.querySelector("#position001").scrollIntoView(true);
				let num = Number(this.positionID.substr(-1));
				switch (num) {
					case 1:
						this.selectType({
							name: "1",
							text: "商标"
						});
						break;
					case 2:
						this.selectType({
							name: "2",
							text: "地理标志"
						});
						break;
					case 3:
						this.selectType({
							name: "3",
							text: "专利"
						});
						break;
					case 4:
						this.selectType({
							name: "4",
							text: "版权"
						});
						break;
					case 5:
						this.selectType({
							name: "5",
							text: "互联网"
						});
						break;
					case 6:
						this.selectType({
							name: "6",
							text: "项目服务"
						});
						break;
				}
				this.loadList();
			}
		},
		props: {
			tabIndexI: {
				type: Number,
				default: 0,
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "../assets/style/index.scss";

	/deep/ .el-tabs__item.is-active {
		font-size: 1.25rem !important;
		line-height: 1rem !important;
		color: #0055a2 !important;
	}

	/deep/ .el-tabs__item {
		color: #333 !important;
		font-size: 1rem;
		height: auto;
	}

	/deep/ .el-tabs__active-bar {
		background: #0c56b0 !important;
	}

	/deep/ .el-tabs__nav-wrap::after {
		background: none !important;
	}

	.expertThinkTank {

		background: #fff !important;
		    // width: 70vw;
		    margin: 0 auto;

		.content-bg {
			background: #f7f7f7 !important;
			padding: 2rem;

			.content {
				min-width: 1200px;
				width: 62.5vw;
				height: auto;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;
				flex-wrap: nowrap;

				.el_input {
					width: 19.625rem;
					display: flex;
					flex-wrap: nowrap;
					border: 1px solid #0055a2;

					.el-input {
						width: 14.375rem;

						/deep/ .el-input__inner {
							border: none !important;
						}
					}

					span {
						width: 5.25rem;
						height: 2.5rem;
						color: #fff;
						background: #0055a2;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
					}
				}
			}
		}

		.serviceBg {
			background: url(../../static/imgs/serviceCase/bg.png) no-repeat top;

			.serveContent {
				margin: 0 auto;
				width: 62.5vw;
				padding-bottom: 4rem;

				h1 {
					font-size: 2.25rem;
					color: #fff;
					line-height: 9rem;
				}

				.serveDescribe {
					padding: 4.5rem 8.5rem 1.5rem 3.75rem;

					li {
						display: flex;
						padding-bottom: 3rem;

						.servicePhoto {
							margin-right: 4.5rem;
						}

						.serviceParagraph {
							font-size: 0.875rem;
							color: #333;
						}
					}
				}
			}
		}

		.classification {
			background: #fff;

			.middle {
				max-width: 1200px;
				margin: 0 auto;
				display: flex;
				padding: 2.5rem 0 1.375rem;
				flex-wrap: wrap;

				.button {
					background: #edeef0;
					color: #333;
					margin-bottom: 1rem;
				}
			}
		}

		.checked {
			background: #0055a2 !important;
			color: #fff !important;
		}

		.caseCentral {
			display: flex;
			flex-wrap: wrap;
			width: 110%;

			.caseDescription {
				width: 23.75rem;
				margin-right: 1.875rem;
				margin-bottom: 1.875rem;
				background: #ffffff;
				box-shadow: 0px 0px 16px 2px rgba(4, 0, 0, 0.06);

				.casephoto {
					width: 23.75rem;
					height: 13.45rem;
					overflow: hidden;

					img {
						width: 23.75rem;
					}
				}

				.caseSection {
					padding: 0 1rem 1.875rem 1rem;
				}

				h1 {
					font-size: 1.25rem;
					color: #333;
					padding: 1.5rem 0 1rem 0;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				p {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 5;
					overflow: hidden;
					font-size: 0.875rem;
				}
			}
		}

		.pagination {
			margin: 3.5rem 0;
			text-align: center;
		}
	}

	@media screen and (max-width: 500px) {
		.expertThinkTank {
			 width: 100vw;
			.content-bg {
				padding: 10px 5px;

				.content {
					width: auto;
					display: inherit;
					min-width: auto;

					.el_input {
						margin: 5px 0;
						border: none;
					}
				}
			}

			.classification {
				margin: 0 5px;
			}
		}
	}

	.expertThinkTank_center {
		min-height: 200px;
		max-width: 1200px;
	}
	@media screen and (max-width: 500px) {
		.expertThinkTank_center{
			max-width:auto;
			min-height:auto;
			.caseCentral{
				width: 100vw;
				.caseDescription{
					margin: 0 auto;
				}
			}
		}
	}
</style>
